var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-common-filter', _vm._b({
    on: {
      "input": function ($event) {
        _vm.updatedCount = 0;
      }
    },
    model: {
      value: _vm.searchDateValue,
      callback: function ($$v) {
        _vm.searchDateValue = $$v;
      },
      expression: "searchDateValue"
    }
  }, 'statistics-common-filter', {
    loading: _vm.loading
  }, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-main-visits', _vm._g(_vm._b({}, 'statistics-main-visits', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-main-current', _vm._g(_vm._b({}, 'statistics-main-current', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    staticStyle: {
      "width": "480px",
      "max-width": "100%"
    },
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('statistics-main-referrer', _vm._g(_vm._b({}, 'statistics-main-referrer', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('statistics-main-users', _vm._g(_vm._b({}, 'statistics-main-users', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('statistics-main-device', _vm._g(_vm._b({}, 'statistics-main-device', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('statistics-main-browser', _vm._g(_vm._b({}, 'statistics-main-browser', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('statistics-main-os', _vm._g(_vm._b({}, 'statistics-main-os', {
    searchDateValue: _vm.searchDateValue
  }, false), {
    updated: _vm.updated
  }))], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }